module.exports = __webpack_public_path__ + "img/insurita-hero-element.4355f2dd.svg";